import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/home.vue'
import Wellcome from '../components/wellcome.vue'
import ViewMaterial from '../view/ViewMaterial.vue'
import Login from '../components/login/login.vue'
import ChangePWD from '../components/ChangePWD/ChangePWD.vue'
import TaskDelivery from '../view/TaskDelivery.vue'
import carControl from '../view/carControl.vue'
import sampleLog from '../view/sampleLog.vue'
import thailandGoods from '../view/thailandGoods.vue'
import module from '@/view/module.vue'
import staffManagement from '@/view/staffManagement.vue'
import usermanager from '@/view/usermanager.vue'
import test6 from '@/view/test6.vue'
import getComputInformation from '@/view/getComputInformation.vue'
import AdministrativeInformation from '@/view/AdministrativeInformation.vue'
import companyManager from '@/view/companyManager.vue'
import cdStockInfo from '@/view/cdStockInfo.vue'
import truckInfo from '@/view/truckInfo.vue'
import driverInfo from '@/view/driverInfo.vue'
import address from '@/view/address.vue'
import taskList from '@/view/taskList.vue'
import freightList from '@/view/freightList.vue'
import dictionaryType from '@/view/dictionaryType.vue'
import dictionaryData from '@/view/dictionaryData.vue'
import preview from '@/components/preview.vue'
import payroll from '@/view/payroll.vue'
import screen from '@/view/screen.vue'
import exportDeclare from '@/view/AEO/exportDeclare.vue'
import exportDeclareML from '@/view/AEO/exportDeclareML.vue'
import importDeclare from '@/view/AEO/importDeclare.vue'
import importDeclareML from '@/view/AEO/importDeclareML.vue'
import declareSearch from '@/view/AEO/declareSearch.vue'
import invtExport from '@/view/AEO/invtExport.vue'
import invtImport from '@/view/AEO/invtImport.vue'
import invtSelect from '@/view/AEO/invtSelect.vue'
import prohibitedClass from '@/view/AEO/prohibitedClass.vue'
import declareUpload from '@/view/AEO/declareUpload.vue'
import importData from '@/view/AEO/importData.vue'
import insWrongRecord from '@/view/AEO/insWrongRecord.vue'
import fa from '@/view/fa.vue'
import goodStockInOut from '@/view/goodStockInOut.vue'
import stock from '@/view/stock.vue'
import files from '@/view/files.vue'
// 仓库
import warehouse from '@/view/wms/basicData/warehouse.vue'
import goods from '@/view/wms/basicData/goods.vue'
import handbook from '@/view/wms/basicData/handbook.vue'
import inAndOutList from '@/view/wms/inAndOutList.vue'
import inWarehouse from '@/view/wms/inWarehouse.vue'
import outbound from '@/view/wms/outbound.vue'
import inventoryList from '@/view/wms/inventoryList.vue'
import interWarehouseList from '@/view/wms/interWarehouseList.vue'
import inventoryMove from '@/view/wms/inventoryMove.vue'
import inAndOutTaskList from '@/view/wms/inAndOutTaskList.vue'
import ownerTransfer from '@/view/wms/ownerTransfer.vue'
import InventoryCountList from '@/view/wms/InventoryCountList.vue'
import InventoryCount from '@/view/wms/InventoryCount.vue'
import locationMap from '@/view/wms/locationMap.vue'
import wmsDailyReport from '@/view/wms/wmsDailyReport.vue'
import overduePickList from '@/view/wms/overduePickList.vue'


// 引入加载条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
// 配置
NProgress.inc()
NProgress.configure({     
    easing: 'ease',  // 动画方式    
    speed: 800,  // 递增进度条的速度    
    showSpinner: false, // 是否显示加载ico    
    trickleSpeed: 200, // 自动递增间隔    
    minimum: 0.1 // 初始化时的最小百分比
})

Vue.use(VueRouter)

// 所有人都可以访问
const routes = [
    {path: '/', redirect: '/login'},
    {path:'/login', component:Login},
    {path:'/getComputInformation', component:getComputInformation},
    { path: '/preview', component: preview},
    // 访问home时，重定向到wellcome页
    { path: '/changePWD', name: 'changePWD', component: ChangePWD, meta: {title: '修改密码'}},
    { path: '/screen', name: 'screen', component: screen, meta: {title: '大屏'}},
    { path: '/inWarehouse', name: 'inWarehouse', component: inWarehouse, meta: {title: '入库任务单'}},
    { path: '/outbound', name: 'outbound', component: outbound, meta: {title: '出库任务单'}},
    { path: '/inventoryMove', name: 'inventoryMove', component: inventoryMove, meta: {title: '移库任务单'}},
    { path: '/ownerTransfer', name: 'ownerTransfer', component: ownerTransfer, meta: {title: '货转任务单'}},
    { path: '/InventoryCount', name: 'InventoryCount', component: InventoryCount, meta: {title: '盘点任务单'}},
    
    { path: '/home', name: 'home', component: Home, redirect: '/wellcome', meta: {title: '首页'}, 
        children: [
        { path: '/wellcome', name: 'wellcome', component: Wellcome, meta: {title: '首页'}}, 
        { path: '/viewMaterial', name: 'viewMaterial', component: ViewMaterial, meta: {title: '查看物料'}}, 
        { path: '/taskDelivery', name: 'taskDelivery', component: TaskDelivery, meta: {title: '任务下发'}},
        { path: '/carControl', name: 'carControl', component: carControl, meta: {title: '货样广告品'}},
        { path: '/sampleLog', name: 'sampleLog', component: sampleLog, meta: {title: '操作日志'}},
        { path: '/thailandGoods', name: 'thailandGoods', component: thailandGoods, meta: {title: '泰国备件管理'}},
        { path: '/module', name: 'module', component: module, meta: {title: '模块管理'}},
        { path: '/staffManagement', name: 'staffManagement', component: staffManagement, meta: {title: '角色管理'}},
        { path: '/usermanager', name: 'usermanager', component: usermanager, meta: {title: '用户管理'}},
        { path: '/test6', name: 'test6', component: test6, meta: {title: '测试'}},
        { path: '/userPcInfo', name: 'userPcInfo', component: AdministrativeInformation, meta: {title: '行政资产盘查'}},
        { path: '/companyManager', name: 'companyManager', component: companyManager, meta: {title: '企业信息管理'}},
        { path: '/cdStockInfo', name: 'cdStockInfo', component: cdStockInfo, meta: {title: '建发EDI'}},
        { path: '/truckInfo', name: 'truckInfo', component: truckInfo, meta: {title: '车辆信息'}},
        { path: '/driverInfo', name: 'driverInfo', component: driverInfo, meta: {title: '司机信息'}},
        { path: '/address', name: 'address', component: address, meta: {title: '地址信息'}},
        { path: '/taskList', name: 'taskList', component: taskList, meta: {title: '运输任务'}},
        { path: '/freightList', name: 'freightList', component: freightList, meta: {title: '司机运费表'}},
        { path: '/dictionaryType', name: 'dictionaryType', component: dictionaryType, meta: {title: '字典类型'}},
        { path: '/dictionaryData', name: 'dictionaryData', component: dictionaryData, meta: {title: '字典数据'}},
        { path: '/payroll', name: 'payroll', component: payroll, meta: {title: '司机工资表'}},
        { path: '/exportDeclare', name: 'exportDeclare', component: exportDeclare, meta: {title: '出口报关单'}},
        { path: '/exportDeclareML', name: 'exportDeclareML', component: exportDeclareML, meta: {title: '出口备案清单'}},
        { path: '/importDeclare', name: 'importDeclare', component: importDeclare, meta: {title: '进口报关单'}},
        { path: '/importDeclareML', name: 'importDeclareML', component: importDeclareML, meta: {title: '进口备案清单'}},
        { path: '/invtExport', name: 'invtExport', component: invtExport, meta: {title: '出口保税核注清单'}},
        { path: '/invtImport', name: 'invtImport', component: invtImport, meta: {title: '进口保税核注清单'}},
        { path: '/invtSelect', name: 'invtSelect', component: invtSelect, meta: {title: '保税核注清单查询'}},
        { path: '/prohibitedClass', name: 'prohibitedClass', component: prohibitedClass, meta: {title: '禁止、限制类商品'}},
        { path: '/declareUpload', name: 'declareUpload', component: declareUpload, meta: {title: '上传单据'}},
        { path: '/declareSearch', name: 'declareSearch', component: declareSearch, meta: {title: '报关查询'}},
        { path: '/importData', name: 'importData', component: importData, meta: {title: '数据导入'}},
        { path: '/insWrongRecord', name: 'insWrongRecord', component: insWrongRecord, meta: {title: '驳回记录'}},
        { path: '/goodStockInOut', name: 'goodStockInOut', component: goodStockInOut, meta: {title: '物资出入库'}},
        { path: '/fa', name: 'fa', component: fa, meta: {title: '资产管理'}},
        { path: '/stock', name: 'stock', component: stock, meta: {title: '物资库存'}},
        { path: '/files', name: 'files', component: files, meta: {title: '文件管理'}},
        // 仓库
        { path: '/warehouse', name: 'warehouse', component: warehouse, meta: {title: '仓库信息'}},
        { path: '/goods', name: 'goods', component: goods, meta: {title: '货物信息'}},
        { path: '/handbook', name: 'handbook', component: handbook, meta: {title: '账册信息'}},
        { path: '/inAndOutList', name: 'inAndOutList', component: inAndOutList, meta: {title: '出入库任务列表'}},
        { path: '/inventoryList', name: 'inventoryList', component: inventoryList, meta: {title: '库存列表'}},
        { path: '/interWarehouseList', name: 'interWarehouseList', component: interWarehouseList, meta: {title: '移库列表'}},
        { path: '/inAndOutTaskList', name: 'inAndOutTaskList', component: inAndOutTaskList, meta: {title: '出入库作业列表'}},
        { path: '/InventoryCountList', name: 'InventoryCountList', component: InventoryCountList, meta: {title: '盘点作业列表'}},
        { path: '/locationMap', name: 'locationMap', component: locationMap, meta: {title: '库位图'}},
        { path: '/wmsDailyReport', name: 'wmsDailyReport', component: wmsDailyReport, meta: {title: '日收发存报表'}},
        { path: '/overduePickList', name: 'overduePickList', component: overduePickList, meta: {title: '保税提离'}},

        ] 
    },
   
]

const router = new VueRouter({
  routes
})

/**
 * 挂载路由守卫
 * to 代表将要访问的路径
 * from 代表从哪个路径跳转而来
 * next 是一个函数，next() 放行。   next('/login') 强制跳转
 */
router.beforeEach((to, from, next) => {
    // 加载条
    NProgress.start()

    //放行
    next() 
})


// 挂载路由守卫 - 访问结束
router.afterEach(() => {
    // 关闭加载条
    NProgress.done()
})

export default router
